import { Divider, Grid, ListItem, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import FeatherIcon from "feather-icons-react";
import React from "react";
import CommonFormikComponent from "../../components/common-form/index.jsx";
import PasswordInput from "../../components/common-form/password-input/index.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import { useSnackbar } from "../../components/toast/index.jsx";
import { InfoTooltip } from "../../consts.js";
import { PASSWORD_UPDATE_FAILED, PASSWORD_UPDATE_SUCCESS } from "../../helpers/messages.js";
import { changePasswordAPI } from "../../services/user.js";
import { ChangePasswordPageSchema } from "./validator.js";

function ChangePasswordForm() {
    const showSnackbar = useSnackbar();
    const { themeMode } = useThemeMode();

    /**
     * Initial Form Values
     */
    const initialValues = {
        current_password: "",
        new_password: "",
        confirm_password: "",
    };

    /**
     * Submit Method to call when user save button
     * @async
     * @param {FormValues} values
     * @param {any} actions
     * @returns {*}
     */
    const submitForm = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);

        const formData = {
            PreviousPassword: values.current_password,
            ProposedPassword: values.new_password,
        };
        try {
            await changePasswordAPI(formData);
            showSnackbar(PASSWORD_UPDATE_SUCCESS);
            setSubmitting(false);
            resetForm();
        } catch (error) {
            setSubmitting(false);
            console.log(error)
            let message = error.message !== "Incorrect username or password." ? error.message : PASSWORD_UPDATE_FAILED;
            if (error?.data?.length) {
                message += "\n" + error.data.join("\n");
            }
            showSnackbar(message, 'error')
        }
    };

    const getTooltipText = () => {
        return (
            <div>
                <Typography variant="subtitle1">
                    Password Requires:
                </Typography>
                <ListItem disableGutters sx={{ display: "flex", alignItems: "center", gap: 1, py: .25 }}>
                    <FeatherIcon icon="check-circle" size={16} />
                    <Typography variant="body2">1 Uppercase Letter</Typography>
                </ListItem>
                <ListItem disableGutters sx={{ display: "flex", alignItems: "center", gap: 1, py: .25 }}>
                    <FeatherIcon icon="check-circle" size={16} />
                    <Typography variant="body2">1 Lowercase Letter</Typography>
                </ListItem>
                <ListItem disableGutters sx={{ display: "flex", alignItems: "center", gap: 1, py: .25 }}>
                    <FeatherIcon icon="check-circle" size={16} />
                    <Typography variant="body2">1 Digit</Typography>
                </ListItem>
                <ListItem disableGutters sx={{ display: "flex", alignItems: "center", gap: 1, py: .25 }}>
                    <FeatherIcon icon="check-circle" size={16} />
                    <Typography variant="body2">1 Special Character</Typography>
                </ListItem>
                <ListItem disableGutters sx={{ display: "flex", alignItems: "center", gap: 1, py: .25 }}>
                    <FeatherIcon icon="check-circle" size={16} />
                    <Typography variant="body2">Minimum 8 characters long</Typography>
                </ListItem>
            </div>
        )
    }

    return (
        <CommonFormikComponent
            validationSchema={ChangePasswordPageSchema}
            initialValues={initialValues}
            onSubmit={submitForm}
            formClassName="d-flex flex-column flex-grow-1 overflow-auto"
        >
            {(formikProps) => (
                <>
                    <Divider sx={{ my: 3 }} />
                    <Grid container>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Stack direction="row" gap={.5} alignItems="center">
                                        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                                            Change Password
                                        </Typography>
                                        <InfoTooltip info={getTooltipText()} themeMode={themeMode} />
                                    </Stack>
                                </Grid>
                                <Grid item xs={12}>
                                    <PasswordInput
                                        label="Current Password"
                                        name="current_password"
                                        value={formikProps.values.current_password}
                                        onChange={formikProps.handleChange}
                                        onBlur={formikProps.handleBlur}
                                        error={formikProps.errors.current_password}
                                        touched={formikProps.touched.current_password}
                                        validationSchema={ChangePasswordPageSchema}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PasswordInput
                                        label="New Password"
                                        name="new_password"
                                        value={formikProps.values.new_password}
                                        onChange={formikProps.handleChange}
                                        onBlur={formikProps.handleBlur}
                                        error={formikProps.errors.new_password}
                                        touched={formikProps.touched.new_password}
                                        validationSchema={ChangePasswordPageSchema}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PasswordInput
                                        label="Confirm Password"
                                        name="confirm_password"
                                        value={formikProps.values.confirm_password}
                                        onChange={formikProps.handleChange}
                                        onBlur={formikProps.handleBlur}
                                        error={formikProps.errors.confirm_password}
                                        touched={formikProps.touched.confirm_password}
                                        validationSchema={ChangePasswordPageSchema}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={formikProps.isSubmitting}
                                        size="large"
                                    >
                                        {formikProps.isSubmitting ? "Updating..." : "Update Password"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )}
        </CommonFormikComponent>
    );
}

export default ChangePasswordForm;
